import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-navy-600 last:border-0" data-id="element-66">
      <button onClick={onClick} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-67">
        <h3 className={`text-lg md:text-xl font-serif pr-8 transition-colors ${isOpen ? 'text-gold' : 'text-cream group-hover:text-gold/80'}`} data-id="element-68">
          {question}
        </h3>
        <ChevronDownIcon className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'text-gold rotate-180' : 'text-muted'}`} data-id="element-69" />
      </button>
      <AnimatePresence data-id="element-70">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-71">
            <p className="pb-6 text-muted leading-relaxed" data-id="element-72">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si compartimos habitación?',
    a: 'Sí, incluimos una sección específica para espacios pequeños y room-sharing.'
  }, {
    q: '¿Tengo que dejarlo llorar por horas?',
    a: 'No. Usamos una intervención gradual que prioriza el consuelo sin crear dependencia.'
  }, {
    q: '¿El Daycare cooperará?',
    a: 'Te damos una guía exacta de qué decirles para que sigan tu plan de sueño sin fricciones.'
  }];
  return <section className="py-24 px-4 bg-navy-800" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <FadeIn data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-12 text-center" data-id="element-76">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-77">
          <div className="bg-navy-900 rounded-2xl p-6 md:p-8 border border-navy-700" data-id="element-78">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-79" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}